module.exports = __webpack_public_path__ + "img/GENERAL-SWIFT-2021-1.750b6ff6.jpg";